export default "__VITE_ASSET__BIu1jhpF__"